
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new",
      function () {
        return require("private-next-pages/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new"])
      });
    }
  